import { Action } from "../../../actions/actions";
import { MailingActionTypes } from "../actions/actionTypes";
import _ from "lodash";

export function mailingLists(state: any[] = [], action: Action) {
    switch (action.type) {
        case MailingActionTypes.TOGGLE_MAILING_LIST_ACTIVE_SUCCESS:
            let newState = _.cloneDeep(state);
            const index = _.findIndex(newState.results, [
                "id",
                action.payload.id
            ]);
            if (index > -1) {
                newState.results[index].active = action.payload.active;
            }
            return newState;
        case MailingActionTypes.GET_MAILING_LISTS_SUCCESS:
            return action.payload
                ? _.cloneDeep(action.payload)
                : [];
        default:
            return state;
    }
}

export function mailingListsLoading(state: boolean = false, action: Action) {
    switch (action.type) {
        case MailingActionTypes.GET_MAILING_LISTS:
            return true;

        case MailingActionTypes.GET_MAILING_LISTS_FAIL:
        case MailingActionTypes.GET_MAILING_LISTS_SUCCESS:
            return false;

        default:
            return state;
    }
}

export function mailingListLoading(state: boolean = false, action: Action) {
    switch (action.type) {
        case MailingActionTypes.GET_MAILING_LIST:
            return true;
        case MailingActionTypes.GET_MAILING_LIST_FAIL:
        case MailingActionTypes.GET_MAILING_LIST_SUCCESS:
            return false;
        default:
            return state;
    }
}

export function editingMailingList(state: any = {}, action: Action) {
    switch (action.type) {
        case MailingActionTypes.CLEAR_MAILING_LISTS:
            return {};
        case MailingActionTypes.UPDATE_MAILING_LISTS:
            return {
                ...state,
                ...action.payload.mailingList
            };
        case MailingActionTypes.GET_MAILING_LIST_SUCCESS:
        case MailingActionTypes.ADD_MAILING_LISTS_SUCCESS:
            return {
                ...state,
                ...action.payload
            };
        default:
            return state;
    }
}

export function submitMailingListLoading(state: boolean = false, action: Action): boolean {
    switch (action.type) {
        case MailingActionTypes.ADD_MAILING_LISTS:
        case MailingActionTypes.EDIT_MAILING_LIST:
            return true;
        case MailingActionTypes.ADD_MAILING_LISTS_SUCCESS:
        case MailingActionTypes.ADD_MAILING_LISTS_FAIL:
        case MailingActionTypes.EDIT_MAILING_LIST_SUCCESS:
        case MailingActionTypes.EDIT_MAILING_LIST_FAIL:
            return false;
        default:
            return state;
    }
}

export function submittingMailingListState(
    state: {
        error: boolean;
        success: boolean;
        message: string | null;
    } | null = null,
    action: Action
): {
    error: boolean;
    success: boolean;
    message: string | null;
} | null {
    switch (action.type) {
        case MailingActionTypes.CLEAR_MAILING_LISTS:
        case MailingActionTypes.CLEAR_SUBMIT_MAILING_LIST:
            return null;
        case MailingActionTypes.ADD_MAILING_LISTS_SUCCESS:
        case MailingActionTypes.EDIT_MAILING_LIST_SUCCESS:
            return {
                error: false,
                success: true,
                message: null
            };
        case MailingActionTypes.ADD_MAILING_LISTS_FAIL:
        case MailingActionTypes.EDIT_MAILING_LIST_FAIL:
            return {
                error: true,
                success: false,
                message: action.message ? action.message : null
            };
        default:
            return state;
    }
}

export function mailingTypes(state: any[] = [], action: Action) {
    switch (action.type) {
        case MailingActionTypes.GET_MAILING_LISTS_TYPES_SUCCESS:
            return action.payload;
        default:
            return state;
    }
}

export function mailingTypesLoading(state: boolean = false, action: Action) {
    switch (action.type) {
        case MailingActionTypes.GET_MAILING_LISTS_TYPES:
            return true;
        case MailingActionTypes.GET_MAILING_LISTS_TYPES_FAIL:
        case MailingActionTypes.GET_MAILING_LISTS_TYPES_SUCCESS:
            return false;
        default:
            return state;
    }
}
